import { render, staticRenderFns } from "./aftersale_apply_list.vue?vue&type=template&id=c799f764&scoped=true"
import script from "./aftersale_apply_list.vue?vue&type=script&lang=js"
export * from "./aftersale_apply_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c799f764",
  null
  
)

export default component.exports